(function () {
  function parseMoney(text) {
    if (!text) return null;
    var match = text.trim().match(/^(\D*)([\d,]+\.\d{2})(\D*)$/);
    if (!match) return null;
    return { prefix: match[1], value: parseFloat(match[2].replace(/,/g, '')), suffix: match[3] };
  }

  function findPriceEl(root) {
    return root.querySelector('.price .price-item--regular, .price .price-item--sale');
  }

  function findQuantityInput(root) {
    return root.querySelector('.product-form__quantity input[type="number"], quantity-input input[type="number"], input[name="quantity"]');
  }

  function ensureTotalEl(root, priceEl) {
    var totalEl = root.querySelector('.quantity-total-price');
    if (totalEl && totalEl.isConnected) return totalEl;
    totalEl = document.createElement('p');
    totalEl.className = 'quantity-total-price';
    totalEl.style.margin = '0.5rem 0 0';
    totalEl.style.fontWeight = '600';
    var priceContainer = priceEl.closest('.price') || priceEl.parentElement;
    priceContainer.insertAdjacentElement('afterend', totalEl);
    return totalEl;
  }

  function setupProductForm(productForm) {
    var sectionId = productForm.dataset.sectionId;
    if (!sectionId) return;
    var root = document.getElementById('shopify-section-' + sectionId);
    if (!root || root.dataset.qtyTotalInit === 'true') return;

    var quantityInput = findQuantityInput(root);
    var priceEl = findPriceEl(root);
    if (!quantityInput || !priceEl) return;

    root.dataset.qtyTotalInit = 'true';

    var isUpdating = false;

    function update() {
      var currentPriceEl = findPriceEl(root);
      var currentQtyInput = findQuantityInput(root);
      if (!currentPriceEl || !currentQtyInput) return;

      var totalEl = ensureTotalEl(root, currentPriceEl);
      var money = parseMoney(currentPriceEl.textContent);
      var qty = parseInt(currentQtyInput.value, 10);

      isUpdating = true;
      if (!money || !qty || qty <= 1) {
        totalEl.textContent = '';
      } else {
        var total = (money.value * qty).toFixed(2);
        totalEl.textContent = 'Total for ' + qty + ': ' + money.prefix + total + money.suffix;
      }
      window.setTimeout(function () { isUpdating = false; }, 0);
    }

    root.addEventListener('input', function (e) {
      if (e.target && e.target.closest('input[type="number"]')) update();
    });
    root.addEventListener('change', function (e) {
      if (e.target && e.target.closest('input[type="number"]')) update();
    });

    var observer = new MutationObserver(function () {
      if (isUpdating) return;
      update();
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });

    update();
  }

  function init() {
    document.querySelectorAll('product-form').forEach(setupProductForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
